import { gql } from '@apollo/client';

export const GET_COMPANY_DETAILS = gql`
  query GetCompanyDetails($clientId: ID!) {
    client(id: $clientId) {
      id
      businessName
      industry
      filingType
      taxClientStatus
      fiscalYearEnd {
        month
        day
      }
      businessProfile {
        legalBusinessName
        yearFounded
        milestones
        filesDelawareFranchiseTax
      }
      personRelationships {
        person {
          id
          fullName
          email
          phone
        }
        role
      }
      clientInfo {
        equityHolders {
          firstName
          lastName
          percentOwnership
        }
        onboarding {
          track1099
          expectedTaxPreparerMeetingDate
          accountsToTrackComplete
          financialAccounts {
            institution
            accountHolder
            accountType
            last4Digits
            businessUsePercentage
          }
          transferApps {
            appName
            accountHolder
            businessUsePercentage
          }
          loansAndLeases {
            institution
            accountHolder
            loanPurpose
          }
          revenueCollection
          payroll
          other
        }
      }
    }
    clientSettings(clientId: $clientId, settings: ["collectOnboardingData"]) {
      name
      defaultValue
      currentValue
    }
  }
`;
